// store/slices/excludedSubjectSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ExcludedSubjectProductForEdit } from '../../../types/purchases/ExcludedSubjectPurchase';

interface ExcludedSubjectState {
  productToEdit: ExcludedSubjectProductForEdit | null;
  serviceToEdit: ExcludedSubjectProductForEdit | null;
  showAddProductModal: boolean;
  showAddServiceModal: boolean;
  showEditProductModal: boolean;
  showEditServiceModal: boolean;
}

const initialState: ExcludedSubjectState = {
  productToEdit: null,
  showAddProductModal: false,
  showEditProductModal: false,
  showAddServiceModal: false,
  serviceToEdit: null,
  showEditServiceModal: false
};

const excludedSubjectSlice = createSlice({
  name: 'excludedSubject',
  initialState,
  reducers: {
    setProductToEdit(state, action: PayloadAction<ExcludedSubjectProductForEdit>) {
      state.productToEdit = action.payload;
    },
    clearProductToEdit(state) {
      state.productToEdit = null;
    },
    setServiceToEdit(state, action: PayloadAction<ExcludedSubjectProductForEdit>) {
      state.serviceToEdit = action.payload;
    },
    clearServiceToEdit(state) {
      state.serviceToEdit = null;
    },
    openAddProductModal(state) {
      state.showAddProductModal = true;
    },
    closeAddProductModal(state) {
      state.showAddProductModal = false;
    },
    openAddServiceModal(state) {
      state.showAddServiceModal = true;
    },
    closeAddServiceModal(state) {
      state.showAddServiceModal = false;
    },
  },
});

export const {
  setProductToEdit,
  clearProductToEdit,
  openAddProductModal,
  closeAddProductModal,
  openAddServiceModal,
  closeAddServiceModal,
  setServiceToEdit,
  clearServiceToEdit,
} = excludedSubjectSlice.actions;

export default excludedSubjectSlice.reducer;
